var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookPurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5920_14445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.003 12.0726C24.003 5.40356 18.63 -0.00244141 12.003 -0.00244141C5.373 -0.000941406 0 5.40356 0 12.0741C0 18.0996 4.389 23.0946 10.125 24.0006V15.5631H7.08V12.0741H10.128V9.41156C10.128 6.38606 11.9205 4.71506 14.661 4.71506C15.975 4.71506 17.3475 4.95056 17.3475 4.95056V7.92056H15.834C14.3445 7.92056 13.8795 8.85206 13.8795 9.80756V12.0726H17.2065L16.6755 15.5616H13.878V23.9991C19.614 23.0931 24.003 18.0981 24.003 12.0726Z",
    fill: "#8601C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5920_14445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookPurple);
export default __webpack_public_path__ + "static/media/facebookPurple.13e5d007.svg";
export { ForwardRef as ReactComponent };